import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  Gauge, ChatCircleDots, UsersThree, FileText, Broadcast,
  PlugsConnected, UsersFour, SignOut, Lightning,
} from "@phosphor-icons/react";

const links = [
  { to: "/dashboard", label: "Dashboard", icon: Gauge, testid: "nav-dashboard" },
  { to: "/inbox", label: "Inbox", icon: ChatCircleDots, testid: "nav-inbox" },
  { to: "/contacts", label: "Contacts", icon: UsersThree, testid: "nav-contacts" },
  { to: "/cadences", label: "Cadences", icon: Broadcast, testid: "nav-cadences" },
  { to: "/templates", label: "Templates", icon: FileText, testid: "nav-templates" },
  { to: "/integrations", label: "Integrations", icon: PlugsConnected, testid: "nav-integrations" },
  { to: "/team", label: "Team", icon: UsersFour, testid: "nav-team" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/10 bg-[#0A0A0A] flex flex-col">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-sm bg-white flex items-center justify-center">
              <Lightning size={20} weight="fill" className="text-black" />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-white/40 font-mono">Follow-up OS</div>
              <div className="font-heading text-lg leading-none tracking-tight">Omni Reach</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {links.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${
                  isActive
                    ? "bg-white text-black font-medium"
                    : "text-white/60 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <Icon size={18} weight="regular" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-white/10 p-4">
          <div className="text-xs text-white/40 uppercase tracking-widest font-mono mb-2">Session</div>
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-sm bg-white/10 flex items-center justify-center font-mono text-sm">
              {user?.name?.[0]?.toUpperCase() || "?"}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{user?.name}</div>
              <div className="text-[11px] text-white/40 font-mono uppercase tracking-wider">{user?.role}</div>
            </div>
            <button
              data-testid="nav-logout"
              onClick={logout}
              className="p-2 hover:bg-white/5 rounded-sm text-white/60 hover:text-white transition-colors"
              title="Logout"
            >
              <SignOut size={18} />
            </button>
          </div>
        </div>
      </aside>

      <main className="flex-1 min-w-0">{children}</main>
    </div>
  );
}
